import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll after AnimatePresence exit animation completes
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 350);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
